module.exports = {
  copySync: require('./copy-sync')
}



//////////////////
// WEBPACK FOOTER
// ./~/github-download/~/fs-extra/lib/copy-sync/index.js
// module id = 841
// module chunks = 0